(function($) {

	'use strict';

	var init = function() {
		toggleSubmenu()
		burgerToggle()
		hoverMenu()
		initGroupFooter()
		preventDefaultFooterLink()
	};

	var hoverMenu = function() {
		$('header .menu-item-has-children').hover(function() {
			$('body').addClass('hover')
		}, function() {
			$('body').removeClass('hover')
		})
	}

	var toggleSubmenu = function() {
		/*
		$('.menu-item__toggle').click(function() {
			$(this).siblings('.sub-menu').slideToggle(300);
			$(this).parent('.menu-item-has-children').toggleClass('active')
		})*/ 
		if (window.innerWidth <= 992) {
			$('header .menu-item-has-children').click(function(e) {
				$(this).find('.sub-menu').slideToggle(300);
				$(this).toggleClass('active')
				e.preventDefault();
			})
		}
	}

	var burgerToggle = function() {
		$('.header__burger').click(function() {
			$('body').addClass('open');
			$('body, html').css('overflow-x', 'visible')
		})
		$('.header__close').click(function() {
			$('body').removeClass('open')
			$('body, html').css('overflow-x', 'hidden')
		})
	}

	// Footer
	var preventDefaultFooterLink = function() {
		$('.groupFooter__nav .menu-item-has-children > a').click(function( event ) {
			event.preventDefault();
		});
	};

	var initGroupFooter = function() {
        $('.groupFooter__nav .menu-item-has-children > a').on('click', groupFooterArrowClickHandler)
	};   

	var groupFooterArrowClickHandler = function(e) {
		var arrow = $(e.currentTarget)
		arrow.toggleClass('opened')
		arrow.next().toggleClass('opened')
		arrow.siblings('.sub-menu').toggleClass('opened')
	}; 

	$(document).ready(function() {
		init();
	});

})(jQuery);
